const elementModal = "#npmodal";

const modal = {
    successModal: (title, message = null, redirect = false) => {
        message = message ? message : 'Success';

        if(redirect) {
            $(elementModal).find('.fechar').hide();
        }

        $(elementModal).addClass('open modal-success');
        $(elementModal).find('h2').text(title);
        $(elementModal).find('p').text(message);
        $(elementModal).find('img.success').show();
    },

    errorModal: (title, message = null) => {
        message = message ? message : 'Internal server error';

        $(elementModal).addClass('open modal-error');
        $(elementModal).find('h2').text(title);
        $(elementModal).find('p').text(message);
        $(elementModal).find('img.error').show();
    },

    loadingModal: (title, message = null) => {
        message = message ? message : 'Loading';

        $(elementModal).addClass('open modal-process');
        $(elementModal).find('h2').text(title);
        $(elementModal).find('p').text(message);
        $(elementModal).find('img.loading').show();
    },

    processingModal: (title, message = null) => {
        message = message ? message : 'Processing';

        $(elementModal).addClass('open modal-process');
        $(elementModal).find('h2').text(title);
        $(elementModal).find('p').text(message);
        $(elementModal).find('img.waiting').show();
    },

    closeModal: () => {
        $(elementModal).find('h2').text('');
        $(elementModal).find('p').text('');
        $(elementModal).removeClass('open modal-process modal-error modal-success');
        
        $(elementModal).find('img.waiting').hide();
        $(elementModal).find('img.error').hide();
        $(elementModal).find('img.loading').hide();
        $(elementModal).find('.fechar').show();
    }
}

export default modal;